import { action } from 'easy-peasy';
import { IActionResetPagination } from '../types';

const resetPagination: IActionResetPagination = action(state => {
  state.pagination.pageNumber = 1;
});

export default resetPagination;
